import { useTheme } from "styled-components";
import { IStyledTheme } from "../theme/types";

function useAppTheme() {
  const theme = useTheme() as IStyledTheme;
  return theme;
}

export default useAppTheme;
